import { _ } from "extensions/underscore";

import { Presenter } from "common/components/table/cells/generic";
import presenterTemplate from "./linkCellPresenter.jst";

export class LinkPresenter extends Presenter {
    contentTemplate = (...args) => presenterTemplate(...args);
    
    itemContent(column, content, rowModelData, rowModel) {
        return this.contentTemplate({
            tooltip: _.resultPartial(column, "tooltip", "", rowModel),
            url: content,
            icon: _.resultPartial(column.cellOptions, "icon", "", rowModel)
        });
    }
}
